<template>
  <!--协议商品-->
  <div>
    <div class="container">
      <e-search
        :count="count"
        :data="filterInfo.data"
        :field-list="filterInfo.fieldList"
        :list-type-info="listTypeInfo"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
        @handleFocus="focusClassify"
      ></e-search>
    </div>
    <div class="margin-b20">
      <eui-btn type="primary" @click="handleAddProduct">添加商品</eui-btn>
      <eui-btn type="primary" @click="importProduct">导入商品</eui-btn>
      <eui-btn type="primary" @click="handleChangePrice">批量调价</eui-btn>
      <eui-btn type="primary" @click="importChangePrice">导入调价</eui-btn>
      <eui-btn type="primary" @click="handleBatchRemove">批量移除</eui-btn>
      <eui-btn type="primary" @click="exportCentralizedSku">商品导出</eui-btn>
      <eui-btn type="text" @click="viewImportResult">查看导入结果</eui-btn>
    </div>

    <div class="container">
      <tableList
        ref="multipleTable"
        maxHeight="600"
        row-key="priceId"
        :loading="false"
        :table-data="tableData"
        :table-label="tableLabel"
        :selection-show="selectionShow"
        :handle-is-selection="handleIsSelection"
        @handleSelectionChange="handleSelectionChange"
      >
        <template #operate="slot">
          <eui-btn type="text" size="12" @click="handleRemove(slot.scope.row)"
            >移除</eui-btn
          >
          <eui-btn
            type="text"
            size="12"
            @click="handleAdjustPriceLog(slot.scope.row)"
            >调价日志</eui-btn
          >
        </template>
      </tableList>
      <div class="pagination flex-right">
        <!--               <el-checkbox v-model="selectAllData" :disabled="tableData.length === 0">全部页下数据</el-checkbox>-->
        <el-pagination
          background
          :page-sizes="[10, 20,50,100,200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="queryData.pageNum"
          :page-size="queryData.pageSize"
          :total="queryData.pageTotal"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <e-dialog
      dialog-title="提示"
      :center-dialog-visible="removeVisible"
      popup-width="400px"
      :sub-btn="subBtn"
      :show-sub-btn="showSubBtn"
      @resetPopupData="handleClose('removeVisible')"
      @submitPopupData="submitPopupData"
    >
      <div>确定要移除选择的商品吗？</div>
    </e-dialog>
    <!--添加商品弹框-->
    <add-product-dialog
      v-if="addProductVisible"
      :add-product-visible="addProductVisible"
      @handleClose="handleClose"
    />
    <!--调价日志弹框-->
    <adjust-price-log-dialog
      v-if="adjustPriceLogrVisible"
      :adjust-price-logr-visible="adjustPriceLogrVisible"
      :price-id="priceId"
      @handleClose="handleClose"
    />
    <!-- 所属分类 -->
    <classifyTree
      :classify-visible="classifyVisible"
      :category-tree-data="categoryTreeData"
      :default-checked-keys="defaultCheckedKeys"
      @submitPopupData="classifySubmitPopupData"
      @resetPopupData="classifyResetPopupData"
    ></classifyTree>
    <!--查看导入结果-->
    <view-import-result-dialog
      v-if="importResultVisible"
      :import-result-visible="importResultVisible"
      :import-id-list="agreementData.importIdList"
      @closeDialog="handleClose"
    />
    <!-- 调价 -->
    <price-dialog
      v-if="priceFormVisible"
      :price-form-visible.sync="priceFormVisible"
      :price="adjustPrice"
      @handleAdjustPrice="handleAdjustPrice"
      @closeDialog="handleClose"
    />
    <!--查看导入结果-->
    <view-import-result-dialog
      v-if="importResultVisible"
      :import-result-visible="importResultVisible"
      @closeDialog="handleClose"
    />
    <!-- 导入商品、导入调价模板-->
    <import-template-dialog
      v-if="importVisible"
      :import-visible.sync="importVisible"
      :file-url="fileUrl"
      :down-load-method="downLoadMethod"
      :template-name="templateName"
      @countRefresh="countRefresh"
      @centralizedQuerySkuPage="centralizedQuerySkuPage"
    />
  </div>
</template>

<script>
import eSearch from '@/modules/projectA/components/common/e-search.vue';
import tableList from '@/modules/projectA/components/common/e-table-list';
import eDialog from '@/modules/projectA/components/common/e-dialog.vue';
import utils from '@/modules/projectA//utils/utils';
import api from '../../../../api/product';
import agreementApi from '../../../../api/agreement';
import adjustPriceLogDialog from './common/adjustPriceLogDialog';
import addProductDialog from './common/addProductDialog';
import priceDialog from './common/priceDialog';
import viewImportResultDialog from './common/viewImportResultDialog';
import importTemplateDialog from './common/importTemplateDialog';
import classifyTree from './common/classifyTree';

export default {
  name: 'CollectAgreementManage',
  components: {
    eSearch,
    tableList,
    eDialog,
    adjustPriceLogDialog,
    addProductDialog,
    classifyTree,
    priceDialog,
    viewImportResultDialog,
    importTemplateDialog,
  },
  data() {
    return {
      listTypeInfo: {
        supplierIdList: [],
      },
      selectAllData: false,
      templateName: '',
      downLoadMethod: '', // 下载模板得方法
      fileUrl: '', // 上传文件得方法
      importVisible: false,
      adjustPrice: 0,
      priceFormVisible: false,
      importResultVisible: false,
      priceId: '',
      categoryTreeData: [],
      defaultCheckedKeys: [],
      selectedData: [],
      count: 6,
      adjustPriceLogrVisible: false,
      showSubBtn: true,
      removeVisible: false,
      removeData: [],
      checked: false,
      subBtn: '确定移除',
      selectLoading: false,
      filterInfo: {
        data: {
          skuCode: null,
          skuName: null,
          agreementName: null,
          supplierCompanyId: null,
          categoryName: null,
        },
        fieldList: [
          { label: '商品编号', type: 'input', value: 'skuCode' },
          { label: '商品名称', type: 'input', value: 'skuName' },
          {
            label: '分类',
            type: 'dialog',
            value: 'categoryName',
            placeholder: '支持多选',
          },
          // { label: '协议名称', type: 'input', value: 'agreementName' },
          // {
          //   label: '供应商',
          //   type: 'select',
          //   value: 'supplierCompanyId',
          //   filterable: true,
          //   remote: true,
          //   list: 'supplierIdList',
          //   reserveKeyword: true,
          //   loading: this.selectLoading,
          //   clearable: true,
          //   companyName: true,
          //   remoteMethod: this.queryCompanySupplier,
          // },
        ],
      },
      selectionShow: true,
      tableData: [],
      tableLabel: [
        { label: '商品编号', param: 'skuCode', align: 'center', width: '140' },
        { label: '商品名称', param: 'skuName', align: 'center', width: '300' },
        { label: '所属分类', param: 'categoryName', align: 'center' },
        { label: '市场价(元)', param: 'price', align: 'center', width: '120' },
        {
          label: '惠享价(元)',
          param: 'sharePrice',
          align: 'center',
          width: '120',
        },
        {
          label: '集采价(元)',
          param: 'agreementPrice',
          align: 'center',
          width: '120',
        },
        { label: '供应商名称', param: 'supplierCompanyName', align: 'center' },
        { label: '协议', param: 'agreementName', align: 'center' },
        {
          label: '操作',
          param: '',
          align: 'center',
          slot: 'operate',
          width: '120',
        },
      ],
      agreementData: {},
      queryData: {
        agreementId: '',
        skuCode: null,
        skuName: null,
        agreementName: null,
        supplierCompanyId: null,
        categoryIdList: null,
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      classifyVisible: false,
      addProductVisible: false,
    };
  },
  mounted() {
    this.queryData.agreementId = this.$route.query.agreementId;
    this.centralizedQuerySkuPage();
    this.backAgreementDetail();
  },
  methods: {
    countRefresh(){
      this.$emit('countRefresh');
    },
    async queryCompanySupplier(row) {
      if (row != '') {
        this.selectLoading = true;
        const params = {
          companyName: row,
        };
        const res = await agreementApi.querySupplierList(params);
        if (res.code == '200') {
          this.selectLoading = false;
          // 映射关系
          const keyMap = {
            companyName: 'name',
            companyId: 'id',
          };

          const arr = this.changSelectKey(keyMap, res.data.records);
          this.listTypeInfo.supplierIdList = [...arr];
        }
      } else {
        this.listTypeInfo.supplierIdList = [];
      }
    },
    // 2023-09-06 迭代 开始
    // 通过映射关系进行映射转换
    changSelectKey(keyMap, query) {
      const newArr = query;
      newArr.map((item, index) => {
        const obj = newArr[index];
        for (const key in obj) {
          // key => companyName
          const newkey = keyMap[key];
          if (newkey) {
            // obj['name'] = obj['companyName']
            obj[newkey] = obj[key];
            //  删除原来的key 但是里面的旧key 如果没有映射就删除不了
            // delete obj[key];
          }
          // 删除原来的key 只保留映射关系后的key
          delete obj[key];
        }
      });
      console.log(newArr);
      return newArr;
    },
    // 可以勾选的
    handleIsSelection() {
      if (this.selectAllData) {
        return false;
      }
      return true;
    },
    // 导入商品
    importProduct() {
      this.fileUrl = api.importCentralizedSku;
      this.downLoadMethod = 'downSkuTemplate';
      this.templateName = '商品导入模板';
      this.importVisible = true;
    },
    // 导入调价
    importChangePrice() {
      this.fileUrl = api.importChangePriceCentralized;
      this.downLoadMethod = 'downPriceTemplate';
      this.templateName = '调价导入模板';
      this.importVisible = true;
    },
    viewImportResult() {
      this.importResultVisible = true;
    },
    // 调价
    handleChangePrice() {
      if (this.selectedData.length === 0) {
        this.$message.warning('请先选择商品。');
        return false;
      }
      const priceArr = this.selectedData.map((item) => item.price);
      this.adjustPrice = Math.min(...priceArr);
      this.priceFormVisible = true;
    },
    // 调价
    async handleAdjustPrice(val) {
      const agreementPriceEditList = this.selectedData.map((item) => ({
        priceId: item.priceId,
        sharePrice: item.sharePrice,
        agreementPrice: item.agreementPrice,
        agreementId: this.agreementData.agreementId,
        supplierCompanyId:item.supplierCompanyId,
        skuId:item.skuId
      }));
      const params = {
        type: val.adjustmentType,
        agreementPriceEditList,
      };
      if (val.adjustmentType === 1 || val.adjustmentType === 2) {
        params.percentage = val.percentage;
      } else {
        params.changePrice = val.adjustmentPrice;
      }
      const res = await api.batchChangePrice(params);
      if (res.success) {
        this.priceFormVisible = false;
        this.$message({ message: '调价成功！', type: 'success' });
        this.centralizedQuerySkuPage();
      }
    },
    // 商品导出接口
    async exportCentralizedSku() {
      if (this.tableData.length === 0) {
        this.$message.warning('协议内无商品。');
        return false;
      }
      const params = {
        ...this.queryData,
        skuIdList:
          this.selectedData.length > 0
            ? this.selectedData.map((item) => item.skuId)
            : null,
      };
      const res = await api.exportCentralizedSku(params);
      if (res.type == 'application/json') {
        utils.fileExportResponseError(res);
      } else {
        const name = `${this.agreementData.agreementName}商品导出`;
        utils.downFile(res, name);
      }
    },
    handleSelectionChange(val) {
      this.selectedData = val;
    },
    handleAddProduct() {
      this.addProductVisible = true;
    },
    // 所属分类确定
    classifySubmitPopupData(val) {
      const filterNode = [];
      val.map((item) => {
        if (item.leafFlag) {
          filterNode.push(item);
        }
      });
      this.queryData.categoryIdList = filterNode.map((item) => item.categoryId);
      const arr = val.map((item) => item.categoryName);
      this.filterInfo.data.categoryName = arr.join('、');
      this.classifyVisible = false;
    },
    // 关闭所属分类弹框
    classifyResetPopupData() {
      this.classifyVisible = false;
    },
    // 选择所属分类
    focusClassify() {
      this.queryCentralizedCategoryTreeByAgreementId();
      if (this.queryData.categoryIdList?.length) {
        this.defaultCheckedKeys = this.queryData.categoryIdList;
      }
      this.classifyVisible = true;
    },
    // 搜索得分类弹框
    async queryCentralizedCategoryTreeByAgreementId() {
      const res = await api.queryCentralizedCategoryTreeByAgreementId({
        agreementId: this.queryData.agreementId,
      });
      if (res.success) {
        this.categoryTreeData = res.data.children;
      }
    },
    // 移除
    async submitPopupData() {
      let res = {};
      if (this.selectAllData) {
        res = await api.removeByCondition(this.queryData);
      } else {
        res = await api.centralizedBatchRemove(this.removeData);
      }

      if (res.success) {
        this.$message.success('移除成功。');
        this.centralizedQuerySkuPage();
        this.removeVisible = false;
        this.selectAllData = false;
      }
    },
    handleClose(flag) {
      this[flag] = false;
      this.centralizedQuerySkuPage();
      if (flag === 'addProductVisible') {
        this.$emit('countRefresh');
      }
    },
    handleBatchRemove() {
      if (!this.selectAllData && this.selectedData.length === 0) {
        this.$message.warning('请先选择要移除的商品。');
        return false;
      }
      this.removeData = this.selectedData.map((item) => item.priceId);
      this.removeVisible = true;
    },
    handleRemove(row) {
      this.removeData = [row.priceId];
      this.removeVisible = true;
    },
    handleAdjustPriceLog(row) {
      this.priceId = row.priceId;
      this.adjustPriceLogrVisible = true;
    },
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.centralizedQuerySkuPage();
    },
    handleSizeChange(val) {
      this.queryData.pageNum = 1;
      this.queryData.pageSize = val;
      this.centralizedQuerySkuPage();
    },
    handleFilter(val) {
      this.queryData.skuCode = val.skuCode;
      this.queryData.skuName = val.skuName;
      this.queryData.agreementName = val.agreementName;
      this.queryData.supplierCompanyId = val.supplierCompanyId;
      this.queryData.pageNum = 1;
      this.centralizedQuerySkuPage();
    },
    handleReset() {
      this.queryData.skuCode = null;
      this.queryData.skuName = null;
      this.queryData.agreementName = null;
      this.queryData.supplierCompanyId = null;
      this.queryData.pageNum = 1;
      this.queryData.categoryIdList = null;
      this.filterInfo.data.categoryName = '';
      this.centralizedQuerySkuPage();
    },
    async centralizedQuerySkuPage() {
      const res = await api.centralizedQuerySkuPage(this.queryData);
      if (res.success) {
        this.tableData = res.data.records || [];
        this.queryData.pageTotal = res.data.total;
      }
    },
    async backAgreementDetail() {
      const res = await agreementApi.backAgreementDetail({
        agreementId: this.queryData.agreementId,
      });
      if (res.success) {
        this.agreementData = res.data || {};
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
